module.exports = __webpack_public_path__ + "img/04.55539d54.gif";